// extracted by mini-css-extract-plugin
export default {"squintTransform":"scaleY(0.85)","root":"EyeIcon_root__Gacbw","background":"EyeIcon_background__evMN6","pupil":"EyeIcon_pupil__CnlbB","eyeLidsPath":"EyeIcon_eyeLidsPath__hcSn0"};